import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import rainFallService from "../../services/rainfall-service";
import { Divider, Pagination, Spin, Upload, message } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import moment from "moment";
import { Fab } from "@mui/material";
import Swal from "sweetalert2";
import { URL_BASE } from "../../config/url-server";
import axios from "axios";

import { es } from "date-fns/locale/es";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import fileService from "../../services/file-service";

const AdminRainFall = () => {


  const { Dragger } = Upload;
  const [file, setFile] = useState("NOK");
  const [messageApi, contextHolder] = message.useMessage();
  const [fileList, setFileList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );



  registerLocale("es", es);
  const end_date = moment().endOf("day").toDate();
  const [endDate, setEndDate] = useState(end_date);



  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);


  const [sectionId, setSectionId] = useState("0");
  const [farmId, setFarmId] = useState("0");




  let navigate = useNavigate();
  const [farmName, setFarmName] = useState("");
  const [listLots, setListLots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [title, setTitle] = useState(false);
  const [sessionUser, setSessionUser] = useState("admin");
  const [sessionUserId, setSessionUserId] = useState("1");

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);
  const [total, setTotal] = useState(0);

  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };





  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    reset,
    formState: { errors },
  } = useForm();



  const sourceOptions = [
    { id: "manual", name: "Manual" },
    { id: "sensor", name: "Sensor" },
  ];


  const getFarmName = (code) => {
    const item = listFarms.find(a => a._id == code)
    return item.name
  }


  const getSectionName = (code) => {
    const item = listSection.find(a => a._id == code)
    return item.name
  }

  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      setValue("farm", 0)
    }
  };

  const getListSection = async (e) => {
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }

    setValue("section", 0)

  };



  const getListBySection = async (page) => {
    setLoadingList(true)
    const sectionId = localStorage.getItem("sectionId");
    const dataString = { page, pageSize }
    const response = await rainFallService.getList(dataString);
    if (response.data) {
      setListLots(response.data);
      setTotal(response.total);
    }
    setLoadingList(false)
  };



  const showMessage = (message) => {
    Swal.fire({
      title: 'Mensaje del sistema',
      text: message,
      icon: 'info',
      timer: 3000,
      showConfirmButton: true
    });
  }




  const customSubmit = async (data) => {


    const farmId = getValues("farm")
    const sectionId = getValues("section")
    if (farmId == "0") {
      showMessage("Seleccione una finca")
      return
    }
    if (sectionId == "0") {
      showMessage("Seleccione una sección")
      return
    }
    const farmName = getFarmName(farmId)
    const sectionName = getSectionName(sectionId)

    data.sectionId = sectionId
    data.sectionName = sectionName
    data.farmId = farmId
    data.farmName = farmName
    data.date = dayjs(data.date).format("YYYY-MM-DD");
    data.userId = sessionUserId
    data.userName = sessionUser

    console.log(data.quantity)
    if (!data.quantity) data.quantity = 0;
    setLoading(true)
    const response = await rainFallService.insert(data);
    if (response.data.success) {
      setValue("quantity", "0");
      setValue("observation", "");
      setValue("source", "manual");
      page == 1 ? getListBySection(1) : setPage(1)
      toast('Realizado.', { autoClose: 1000 });
    }
    else {
      toast.error(response.data.message, { autoClose: 2100 })
    }
    setLoading(false)
  };




  const cancelar = async () => {
    setValue("quantity", "0");
    setValue("observation", "");
    setValue("source", "manual");
  };




  const deleteRecord = async (id, date) => {
    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios.', { autoClose: 1000 });
      return;
    }
    else {
      Swal.fire({
        title: `Eliminar registro`,
        html: `Desea eliminar el registro<br/> del día: ${date}?`,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        denyButtonText: `Conservar`
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          const data = { id };
          const response = await rainFallService.deleteRecord(data);
          console.log(response)
          if (response.success) {

            page == 1 ? getListBySection(1) : setPage(1)

            toast(response.message, { autoClose: 1000 });
          }
          else {
            toast.error(response.error, { autoClose: 1000 });
          }
          setLoading(false)
        }
      });
    }
  }



  const props = {
    name: "file",
    height: "100px",
    multiple: false,
    fileList: fileList,
    accept: ".xlsx",
    maxCount: 1,
    action: URL_BASE + "file/upload",

    onChange(info) {


      const username = localStorage.getItem("username");
      if (username != "superadmin") {
        toast.error('Usuario sin privilegios!', { autoClose: 1000 });
        return;
      }



      const res = verifyTitle(info.file.name)
      if (res != "OK") {
        toast.error(res, {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });
        return
      }



      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        const response = info.file.response;
        if (response && response.status === "success") {
          const { originalname, filename, path, size } = response.file;
          toast(`${originalname} subido exitosamente.`, { autoClose: 1000 });
          setValue("filename", originalname)
          setFile(filename);
          setValue("document", filename);
        } else {
          toast.error("Error en la respuesta del servidor.", {
            autoClose: false,
            onClick: () => {
              toast.dismiss();
            }
          });

        }
      } else if (status === "error") {
        toast.error("Error en la respuesta del servidor.", {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });

      }

      setFileList(info.fileList);
    },
    onRemove: async (e) => {
      try {
        const response = await axios.delete(
          `https://core.palmicultor.com.co/api/file/delete/${file}`
        );
        if (response.data.status === "success") {
          toast('Realizado.', { autoClose: 1000 });
          setFile("");
          setFileList([]);
          setValue("document", "");
        } else {


          toast.error(response.data.message, {
            autoClose: false,
            onClick: () => {
              toast.dismiss();
            }
          });

        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },
  };


  const verifyTitle = (fileName) => {


    const farmId = getValues("farm")
    const document = getValues("document")
    const sectionId = getValues("section")
    if (farmId == "0") {
      showMessage("Seleccione una finca")
      return
    }
    if (sectionId == "0") {
      showMessage("Seleccione una sección")
      return
    }
    let sectionName = getSectionName(sectionId)

    fileName = fileName.toUpperCase()
    sectionName = sectionName.toUpperCase()
    if (!fileName.includes(sectionName)) {
      return "Titulo del excel no contiene: " + sectionName;
    }
    if (!fileName.includes("PLUVIOMETRO")) {
      return "Titulo del excel no contiene la palabra: PLUVIOMETRO ";
    }
    return "OK"
  }





  const uploadMovements = async () => {


    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios!', { autoClose: 1000 });
      return;
    }


    const farmId = getValues("farm")
    const document = getValues("document")
    const sectionId = getValues("section")
    if (farmId == "0") {
      showMessage("Seleccione una finca")
      return
    }
    if (sectionId == "0") {
      showMessage("Seleccione una sección")
      return
    }
    const farmName = getFarmName(farmId)
    const sectionName = getSectionName(sectionId)

    const data = { document, farmId, farmName, sectionId, sectionName }
    data.userId = sessionUserId
    data.userName = sessionUser
    data.documentId = document



    setLoading(true)
    const result = await fileService.insertRainFallExcel(data);
    if (result) {
      const success = result.data.success;
      const message = result.data.message;
      if (success) {

        toast.success(
          <div>
            {
              message.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
          </div>, {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });
        setFile("");
        setFileList([]);
        setValue("document", "");
        getListBySection()

      } else {
        toast.error(
          <div>
            {
              message.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
          </div>, {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });
      }
    }
    setLoading(false)
  };




  useEffect(() => {
    const username = localStorage.getItem("username");
    const userId = localStorage.getItem("userId");
    setSessionUser(username)
    setSessionUserId(userId)
    getLisFarm();
    setSectionId("0")
  }, []);



  useEffect(() => {
    getListBySection(page);
  }, [page, pageSize]);





  return (
    <div className="row p-4">
      <ToastContainer />

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >DATOS DEL PLUVIÓMETRO </Divider>
      </div>



      <div className="col-12 col-sm-4">
        <div className="card p-4">
          <form className="form-react" onSubmit={handleSubmit(customSubmit)}>
            <div className="row">


              <div className="col-12 col-sm-12">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-6">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>




              <div className=" col-6 col-sm-6">
                <label>Fecha</label>
                <Controller
                  control={control}
                  defaultValue={endDate}
                  name="date"
                  render={({ field }) => (
                    <DatePicker
                      locale="es"
                      dateFormat="yyyy-MM-dd"
                      className="form-control text-secondary"
                      selected={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />
              </div>


              <div className=" col-6">
                <label>Cantidad ml</label>
                <input
                  type="number"
                  step="any"
                  className="form-control"
                  {...register("quantity")}
                />
              </div>


              <div className=" col-6">
                <label>Método de captura</label>
                <select className="form-control" {...register("source")}>
                  {sourceOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className=" col-12">
                <label>Observación</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("observation")}
                />
              </div>

              <div className=" col-6">
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button className="btn btn-primary w-100" type="submit">
                    Guardar registro
                  </button>
                </Spin>
              </div>

              <div className=" col-6">
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button
                    className="btn btn-secondary w-100"
                    type="button"
                    onClick={() => cancelar()}
                  >
                    <i className="bi bi-x-square fa-lg m-2" /> Cancelar
                  </button>
                </Spin>
              </div>


              <div className=" col-12"><hr></hr></div>



              <div className="col-12 " style={{ height: '130px' }}>
                <div className="row">
                  <div className="col-12">
                    <Dragger {...props}>
                      <p className="ant-upload-hint" >
                        Click o arrastre para subir<br></br>
                        Solo se aceptan archivos con extensión xlsx.<br />
                        <b>Columna A:</b> fecha  <b>Columna B</b>: cantidad
                      </p>

                      
                    </Dragger>
                  </div>
                </div>
              </div>




              <div className=" col-12">
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button className="btn btn-success w-100" type="button" onClick={uploadMovements}>
                    Guardar desde excel
                  </button>
                </Spin>
              </div>






            </div>
          </form>
        </div>

      </div>


      <div className="col-12 col-sm-8">

        <div className="col-8 mb-2">
          <Pagination
            className="text-primary "
            current={page}
            pageSize={pageSize}
            total={total}
            onChange={handlePageChange}
            pageSizeOptions={["5", "10", "20", "50"]}
            showTotal={(total) => `Total ${total} Registros`}
            showSizeChanger
            onShowSizeChange={(current, size) => handlePageChange(1, size)}
          />
        </div>

        <div className="card p-4">
          <div className="card-title">
            <div className="tbl-container bdr">
              <Spin spinning={loadingList}>
                <table className="table ">
                  <thead className="table-primary">
                    <tr>
                      <th >Fecha</th>
                      <th>Finca</th>
                      <th>Sección</th>
                      <th>Cantidad</th>
                      <th>Metodo</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listLots.map((record) => (
                      <tr key={record._id}   >
                        <td className="small" >{record.date.split("T")[0]}</td>
                        <td className="small" >{record.farmName}</td>
                        <td>{record.sectionName}</td>
                        <td>{record.quantity}</td>
                        <td>{record.source}</td>
                        <td style={{ width: "50px", textAlign: 'center' }}  >

                          <button
                            className={sessionUser == "superadmin" ? "btn btn-danger ms-1 fs-6 " : "d-none"}
                            onClick={() => deleteRecord(record._id, record.date.split("T")[0])}
                          >
                            <i className="bi bi-trash fa-lg m-1" />
                          </button>

                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Spin>
            </div>
          </div>
        </div>
      </div>



    </div>
  );
};

export default AdminRainFall;
